import React, { Component } from "react";
import swal from 'sweetalert';
import { NavLink, Link } from "react-router-dom";
import "./index.css";
import styled from 'styled-components';
import LogoMP from "./static/img/logo.png"
import Badge from "@material-ui/core/Badge";
import { Menu, Button, Flex, Avatar, HStack, Text, Icon, MenuList, MenuButton, MenuItem, MenuDivider, VStack} from "@chakra-ui/react";
import { BsFillBellFill } from "react-icons/bs"
import AuthService from "../../services/auth.service";

import '../../../node_modules/font-awesome/css/font-awesome.css';


const currentUser = AuthService.getCurrentUser();
let idMentor;
let idMitra;
let idPeserta;


if (currentUser != undefined) {
  if (currentUser.peserta != null) {
      currentUser.peserta.map((data) => idPeserta=data.idPeserta)
      console.log(idPeserta)
  } else if (currentUser.mitra != null) {
      currentUser.mitra.map((data) => idMitra=data.idMitra)
      console.log(idMitra)
  } else if (currentUser.mentor != null) {
      currentUser.mentor.map((data) => idMentor=data.idMentor)
      console.log(idMentor)
  }
}

const ImageCard = styled.img`
    width: 50px;
    margin-left: 50px;
    object-fit: cover;
    border-radius: 50px;

    @media screen and (max-width: 600px){
        margin-left: 10px;
     }
`
class Navigation extends Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);

    this.state = {
      showPeserta: false,
      showMitra: false,
      showMentor: false,
      showAdmin: false,
      currentUser: undefined,
      click: false,
      
      notifikasiPeserta: [],
      notifikasiBaruPeserta: [],
      notifikasiMitra: [],
      notifikasiBaruMitra: [],
      judul: "",
      isi: "",
      fotoPeserta: undefined,
      fotoMitra: undefined,
      notifPesertaHidden: true,
      notifMitraHidden: true,
    };
  }

  handleClick = () => {
    const click = this.state.click;
    this.setState({ click: !click });
  };


  async getNotifikasiPeserta() {
      fetch(`https://magangprodb.herokuapp.com/api/v1/list-notifikasiPeserta/${idPeserta}`) 
      .then(result => result.json())
      .then(notifikasiPeserta => 
        this.setState({
          notifikasiPeserta : notifikasiPeserta
        }))
  }

  async getNotifikasiBaruPeserta() {
    fetch(`https://magangprodb.herokuapp.com/api/v1/list-notifikasiPeserta/baru/${idPeserta}`) 
    .then(result => result.json())
    .then(notifikasiBaruPeserta => 
      this.setState({
        notifikasiBaruPeserta : notifikasiBaruPeserta,
      }))
  }

  async getNotifikasiMitra() {
    fetch(`https://magangprodb.herokuapp.com/api/v1/list-notifikasiMitra/${idMitra}`) 
    .then(result => result.json())
    .then(notifikasiMitra => 
      this.setState({
        notifikasiMitra : notifikasiMitra,
      }))
  }

  async getNotifikasiBaruMitra() {
    fetch(`https://magangprodb.herokuapp.com/api/v1/list-notifikasiMitra/baru/${idMitra}`) 
    .then(result => result.json())
    .then(notifikasiBaruMitra => 
      this.setState({
        notifikasiBaruMitra : notifikasiBaruMitra,
      }))
  }

  async getPesertaById(){
    fetch(`https://magangprodb.herokuapp.com/api/v1/peserta/${idPeserta}`) 
      .then(result => result.json())
      .then(data => 
        this.setState({
          fotoPeserta : (JSON.parse(data.image)).image
    }))
  };

  async getMitraById(){
    fetch(`https://magangprodb.herokuapp.com/api/v1/mitra/${idMitra}`) 
      .then(result => result.json())
      .then(data2 => 
        this.setState({
          fotoMitra : data2.image
    }))
  };

  handleClickNotifPeserta = () => {
    const notifPesertaHidden = this.state.notifPesertaHidden;
    this.setState({ notifPesertaHidden: !notifPesertaHidden });

    const requestOptions = {
            method: 'PUT'
        };
        fetch(`https://magangprodb.herokuapp.com/api/v1/list-notifikasiPeserta/update/${idPeserta}`, requestOptions)
            .then(response => response.json())
  };

  handleClickNotifMitra = () => {
    const notifMitraHidden = this.state.notifMitraHidden;
    this.setState({ notifMitraHidden: !notifMitraHidden });

    const requestOptions = {
            method: 'PUT'
        };
        fetch(`https://magangprodb.herokuapp.com/api/v1/list-notifikasiMitra/update/${idMitra}`, requestOptions)
            .then(response => response.json())
  };



  componentDidMount() {
    const user = AuthService.getCurrentUser();

    if (user) {
      this.setState({
        currentUser: user,
        showPeserta: user.roles.includes("Peserta"),
        showMitra: user.roles.includes("Mitra"),
        showMentor: user.roles.includes("Mentor"),
        showAdmin: user.roles.includes("Admin"),
      });

      if(user.roles[0] === "Peserta") {
        this.getNotifikasiPeserta();
        this.getNotifikasiBaruPeserta();
        this.getPesertaById();
      }
      else if(user.roles[0] === "Mitra") {
        this.getNotifikasiMitra();
        this.getNotifikasiBaruMitra();
        this.getMitraById();
      }
    }
  }

  logOut() {
    swal({
      title: "Apakah Anda yakin ingin keluar?",
      icon: "warning",
      buttons: ["Tidak", "Iya"],
      dangerMode: true,
    })
    .then((yes) => {
      if (yes) {
        AuthService.logout();
        this.setState({
          showPeserta: false,
          showMitra: false,
          showMentor: false,
          showAdmin: false,
          currentUser: undefined,
        });
        swal({
          title: "Kamu berhasil logout!",
          icon: "success",
          button: "OK",
        });
        window.location.reload();
      } 
    });
  }

  render() {
    const { currentUser, showPeserta, showMentor, 
            showMitra, showAdmin } = this.state;
    return (
      <div>
        <nav className="navbar">
          <div className="nav-container">
            <NavLink exact to="/" className="nav-logo">
              <HStack>
                <ImageCard src={LogoMP} />
                <Text className="logoname" fontFamily= {'Inter'} fontWeight={500}> MagangPro</Text>
              </HStack>
            </NavLink>
            <ul className={this.state.click ? "nav-menu active" : "nav-menu"}>
              <li className="nav-item">
                <NavLink
                  exact
                  to="/"
                  activeClassName="active"
                  className="nav-links"
                  onClick={this.handleClick}
                >
                  Beranda
                </NavLink>
              </li>

              {!showAdmin && !showMitra && !showMentor && (
              <li className="nav-item">
                <NavLink
                  exact
                  to="/lowongan"
                  activeClassName="active"
                  className="nav-links"
                  onClick={this.handleClick}
                >
                  Lowongan Magang
                </NavLink>
              </li>
              )}

              {showPeserta && (
                <li className="nav-item">
                <NavLink
                  exact
                  to={`/peserta/kegiatanku/kegiatanaktif/${idPeserta}`}
                  activeClassName="active"
                  className="nav-links"
                  onClick={this.handleClick}
                >KegiatanKu</NavLink>
                </li>
              )}

            {showMitra && (
                <li className="nav-item">
                <NavLink
                  exact
                  to={`/mitra/profile/lihat/${idMitra}`}
                  activeClassName="active"
                  className="nav-links"
                  onClick={this.handleClick}
                >Dashboard</NavLink>
                </li>
              )}
            
            {showAdmin && (
                <li className="nav-item">
                <NavLink
                  exact
                  to="/admin/verifikasi/proposal"
                  activeClassName="active"
                  className="nav-links"
                  onClick={this.handleClick}
                >Verifikasi</NavLink>
                </li>
              )}
            
            {showMentor && (
                <li className="nav-item">
                <NavLink
                  exact
                  to={`/mentor/profile/lihat/${idMentor}`}
                  activeClassName="active"
                  className="nav-links"
                  onClick={this.handleClick}
                >Dashboard</NavLink>
                </li>
              )}

              {!currentUser && (
              <li className="nav-item">
                <NavLink
                  exact
                  to="/login"
                  activeClassName="active"
                  className="nav-links"
                  onClick={this.handleClick}
                >
                  Login/Register
                </NavLink>
              </li>)}

              {showAdmin && (
              <li className="nav-item">
              <NavLink
                exact
                to="/"
                activeClassName="active"
                className="nav-links"
                onClick={this.logOut}
              >
                Logout
              </NavLink>
              </li>
              )}

              {showMentor && (
              <li className="nav-item">
              <NavLink
                exact
                to="/"
                activeClassName="active"
                className="nav-links"
                onClick={this.logOut}
              >
                Logout
              </NavLink>
              </li>
              )}

              <li className="nav-item">
              {!showMentor && !showAdmin && currentUser && (
              <div className="special">
                 <Menu>
                 {showPeserta && (
                    <MenuButton
                      onClick={this.handleClickNotifPeserta}
                      as={Button}
                      rounded={'full'}
                      variant={'link'}
                      cursor={'pointer'}
                      minW={0}>
                      {this.state.notifPesertaHidden && this.state.notifikasiBaruPeserta.length > 0 ? 
                          <Badge color="secondary" badgeContent={this.state.notifikasiBaruPeserta.length}>
                            <Icon color={'#6554C0'} fontSize={'2xl'} as={BsFillBellFill}/>
                          </Badge>
                        : <Icon color={'#6554C0'} fontSize={'2xl'} as={BsFillBellFill}/>}
                  </MenuButton>
                 )}
                 {showMitra && (
                    <MenuButton
                      onClick={this.handleClickNotifMitra}
                      as={Button}
                      rounded={'full'}
                      variant={'link'}
                      cursor={'pointer'}
                      minW={0}>
                      {this.state.notifMitraHidden && this.state.notifikasiBaruMitra.length > 0 ? 
                          <Badge color="secondary" badgeContent={this.state.notifikasiBaruMitra.length}>
                            <Icon color={'#6554C0'} fontSize={'2xl'} as={BsFillBellFill}/>
                          </Badge>
                        : <Icon color={'#6554C0'} fontSize={'2xl'} as={BsFillBellFill}/>}
                    </MenuButton>
                 )}
                    {showPeserta && (
                      <MenuList p={4}>
                          {this.state.notifikasiPeserta.sort((a, b) => (a > b ? 1 : -1)).slice(0,4).map((data) => 
                          <Link to={`/peserta/kegiatanku/statuspendaftaran/${idPeserta}`}>
                            <MenuItem 
                            backgroundColor={'gray.100'}
                            borderRadius={10}
                            p={2}
                            mb={2}
                            >
                            <VStack spacing={0}
                                    align='stretch'
                                    p={2}
                                    >
                                <Text className="notifheader" fontSize={'l'} fontWeight={'700'}>{data.judul}</Text>
                                <Text className="notifp">{data.notifikasi}</Text>
                              </VStack>
                            </MenuItem>
                            </Link>
                          )}
                      </MenuList>
                    )}
                    {showMitra && (
                      <MenuList p={4}>
                          {this.state.notifikasiMitra.sort((a, b) => (a > b ? 1 : -1)).slice(0,4).map((data) => 
                            <Link to="/mitra/profile/proposal">
                            <MenuItem 
                              backgroundColor={'gray.100'}
                              borderRadius={10}
                              p={2}
                              mb={2}
                              >
                              <VStack spacing={0}
                                      align='stretch'
                                      p={2}
                                      >
                                <Text className="notifheader" fontSize={'l'} fontWeight={'700'}>{data.judul}</Text>
                                <Text className="notifp">{data.notifikasi}</Text>
                              </VStack>
                            </MenuItem>
                            </Link>
                          )}
                      </MenuList>
                    )}
                  </Menu>
              </div>
              )}
              </li>

              <li className="nav-item">
              {currentUser && (
              <div className="special2">
                <Menu>
                  {showPeserta && (
                    <MenuButton
                      as={Button}
                      rounded={'full'}
                      variant={'link'}
                      cursor={'pointer'}
                      minW={0}>
                      <Avatar
                        size={'sm'}
                        src={this.state.fotoPeserta}
                      />
                    </MenuButton>
                  )}
                  {showMitra && (
                    <MenuButton
                      as={Button}
                      rounded={'full'}
                      variant={'link'}
                      cursor={'pointer'}
                      minW={0}>
                      <Avatar
                        size={'sm'}
                        src={this.state.fotoMitra}
                      />
                    </MenuButton>
                  )}
                  {showPeserta && (
                      <div>
                        <MenuList>
                          <Link to="/peserta/profile"  onClick={this.handleClick}>
                            <MenuItem>
                              Dashboard
                            </MenuItem>
                          </Link>
                          <MenuDivider />
                          
                          <Link to="/">
                            <MenuItem onClick={this.logOut}>
                              Logout
                            </MenuItem>
                          </Link>
                        </MenuList>
                      </div>
                    )}

                    {!showPeserta && (
                      <div>
                        <MenuList>
                          <MenuItem onClick={this.logOut}>
                            <Link to="/">
                              Logout
                            </Link>
                          </MenuItem>
                        </MenuList>
                      </div>
                    )}

                    {showMentor && (
                      <div>
                        <MenuList>
                          <MenuItem onClick={this.logOut}>
                            <Link to="/">
                              Logout
                            </Link>
                          </MenuItem>
                        </MenuList>
                      </div>
                    )}
                  </Menu>
              </div>
              )}
              </li>
              

            </ul>
            <div className="nav-icon" onClick={this.handleClick}>
              <i className={this.state.click ? "fa fa-times" : "fa fa-bars"}></i>
            </div>

            {currentUser && (
              <div className="minispecial">
                <Flex pr={0} fontFamily='Inter' alignItems={'stretch'}>
                  <Menu>
                    {showPeserta && (
                      <MenuButton
                        onClick={this.handleClickNotifPeserta}
                        as={Button}
                        rounded={'full'}
                        variant={'link'}
                        cursor={'pointer'}
                        minW={0}>
                        {this.state.notifPesertaHidden && this.state.notifikasiBaruPeserta.length > 0 ? 
                            <Badge color="secondary" badgeContent={this.state.notifikasiBaruPeserta.length}>
                              <Icon color={'#6554C0'} fontSize={'2xl'} as={BsFillBellFill}/>
                            </Badge>
                          : <Icon color={'#6554C0'} fontSize={'2xl'} as={BsFillBellFill}/>}
                      </MenuButton>
                    )}
                    {showMitra && (
                        <MenuButton
                          onClick={this.handleClickNotifMitra}
                          as={Button}
                          rounded={'full'}
                          variant={'link'}
                          cursor={'pointer'}
                          minW={0}>
                          {this.state.notifMitraHidden && this.state.notifikasiBaruMitra.length > 0 ? 
                              <Badge color="secondary" badgeContent={this.state.notifikasiBaruMitra.length}>
                                <Icon color={'#6554C0'} fontSize={'2xl'} as={BsFillBellFill}/>
                              </Badge>
                            : <Icon color={'#6554C0'} fontSize={'2xl'} as={BsFillBellFill}/>}
                        </MenuButton>
                    )}
                    {showPeserta && (
                      <MenuList className="menunotif" p={0}>
                          {this.state.notifikasiPeserta.sort((a, b) => (a > b ? 1 : -1)).slice(0,4).map((data) => 
                            <Link to={`/peserta/kegiatanku/statuspendaftaran/${idPeserta}`}>
                            <MenuItem 
                            backgroundColor={'gray.100'}
                            borderRadius={10}
                            p={2}
                            mb={2}
                            >
                            <VStack spacing={0}
                                    align='stretch'
                                    p={2}
                                    >
                                <Text className="notifheader" fontSize={'l'} fontWeight={'700'}>{data.judul}</Text>
                                <Text className="notifp">{data.notifikasi}</Text>
                              </VStack>
                            </MenuItem>
                            </Link>
                          )}
                            
                      </MenuList>
                    )}
                    {showMitra && (
                      <MenuList className="menunotif" p={0}>
                          {this.state.notifikasiMitra.sort((a, b) => (a > b ? 1 : -1)).slice(0,4).map((data) => 
                            <MenuItem 
                              backgroundColor={'gray.100'}
                              borderRadius={10}
                              p={2}
                              mb={1}
                              >
                              <VStack spacing={1}
                                      align='stretch'
                                      p={1}
                                      >
                                <Text className="notifheader" fontSize={'l'} fontWeight={'700'}>{data.judul}</Text>
                                <Text className="notifp">{data.notifikasi}</Text>
                                
                              </VStack>
                            </MenuItem>
                          )}
                            
                      </MenuList>
                    )}
                  </Menu>
                </Flex>
              </div>
            )}
          </div>
        </nav>
      </div>
    );
  }
}

export default Navigation;;